import { Country } from './models/country.model';

export const countries: Country[] = [
  {
    code: 'AF',
    dial_code: '+93',
    flagUrl: 'https://flagcdn.com/24x18/af.png',
    id: 4,
    name: 'Afghanistan',
  },
  {
    code: 'AL',
    dial_code: '+355',
    flagUrl: 'https://flagcdn.com/24x18/al.png',
    id: 8,
    name: 'Albania',
  },
  {
    code: 'DZ',
    dial_code: '+213',
    flagUrl: 'https://flagcdn.com/24x18/dz.png',
    id: 12,
    name: 'Algeria',
  },
  {
    code: 'AD',
    dial_code: '+376',
    flagUrl: 'https://flagcdn.com/24x18/ad.png',
    id: 20,
    name: 'Andorra',
  },
  {
    code: 'AO',
    dial_code: '+244',
    flagUrl: 'https://flagcdn.com/24x18/ao.png',
    id: 24,
    name: 'Angola',
  },
  {
    code: 'AG',
    dial_code: '+1268',
    flagUrl: 'https://flagcdn.com/24x18/ag.png',
    id: 28,
    name: 'Antigua and Barbuda',
  },
  {
    code: 'AZ',
    dial_code: '+994',
    flagUrl: 'https://flagcdn.com/24x18/az.png',
    id: 31,
    name: 'Azerbaijan',
  },
  {
    code: 'AR',
    dial_code: '+54',
    flagUrl: 'https://flagcdn.com/24x18/ar.png',
    id: 32,
    name: 'Argentina',
  },
  {
    code: 'AU',
    dial_code: '+61',
    flagUrl: 'https://flagcdn.com/24x18/au.png',
    id: 36,
    name: 'Australia',
  },
  {
    code: 'AT',
    dial_code: '+43',
    flagUrl: 'https://flagcdn.com/24x18/at.png',
    id: 40,
    name: 'Austria',
  },
  {
    code: 'BS',
    dial_code: '+1242',
    flagUrl: 'https://flagcdn.com/24x18/bs.png',
    id: 44,
    name: 'Bahamas',
  },
  {
    code: 'BH',
    dial_code: '+973',
    flagUrl: 'https://flagcdn.com/24x18/bh.png',
    id: 48,
    name: 'Bahrain',
  },
  {
    code: 'BD',
    dial_code: '+880',
    flagUrl: 'https://flagcdn.com/24x18/bd.png',
    id: 50,
    name: 'Bangladesh',
  },
  {
    code: 'AM',
    dial_code: '+374',
    flagUrl: 'https://flagcdn.com/24x18/am.png',
    id: 51,
    name: 'Armenia',
  },
  {
    code: 'BB',
    dial_code: '+1246',
    flagUrl: 'https://flagcdn.com/24x18/bb.png',
    id: 52,
    name: 'Barbados',
  },
  {
    code: 'BE',
    dial_code: '+32',
    flagUrl: 'https://flagcdn.com/24x18/be.png',
    id: 56,
    name: 'Belgium',
  },
  {
    code: 'BT',
    dial_code: '+975',
    flagUrl: 'https://flagcdn.com/24x18/bt.png',
    id: 64,
    name: 'Bhutan',
  },
  {
    code: 'BO',
    dial_code: '+591',
    flagUrl: 'https://flagcdn.com/24x18/bo.png',
    id: 68,
    name: 'Bolivia (Plurinational State of)',
  },
  {
    code: 'BA',
    dial_code: '+387',
    flagUrl: 'https://flagcdn.com/24x18/ba.png',
    id: 70,
    name: 'Bosnia and Herzegovina',
  },
  {
    code: 'BW',
    dial_code: '+267',
    flagUrl: 'https://flagcdn.com/24x18/bw.png',
    id: 72,
    name: 'Botswana',
  },
  {
    code: 'BR',
    dial_code: '+55',
    flagUrl: 'https://flagcdn.com/24x18/br.png',
    id: 76,
    name: 'Brazil',
  },
  {
    code: 'BZ',
    dial_code: '+501',
    flagUrl: 'https://flagcdn.com/24x18/bz.png',
    id: 84,
    name: 'Belize',
  },
  {
    code: 'SB',
    dial_code: '+677',
    flagUrl: 'https://flagcdn.com/24x18/sb.png',
    id: 90,
    name: 'Solomon Islands',
  },
  {
    code: 'BN',
    dial_code: '+673',
    flagUrl: 'https://flagcdn.com/24x18/bn.png',
    id: 96,
    name: 'Brunei Darussalam',
  },
  {
    code: 'BG',
    dial_code: '+359',
    flagUrl: 'https://flagcdn.com/24x18/bg.png',
    id: 100,
    name: 'Bulgaria',
  },
  {
    code: 'MM',
    dial_code: '+95',
    flagUrl: 'https://flagcdn.com/24x18/mm.png',
    id: 104,
    name: 'Myanmar',
  },
  {
    code: 'BI',
    dial_code: '+257',
    flagUrl: 'https://flagcdn.com/24x18/bi.png',
    id: 108,
    name: 'Burundi',
  },
  {
    code: 'BY',
    dial_code: '+375',
    flagUrl: 'https://flagcdn.com/24x18/by.png',
    id: 112,
    name: 'Belarus',
  },
  {
    code: 'KH',
    dial_code: '+855',
    flagUrl: 'https://flagcdn.com/24x18/kh.png',
    id: 116,
    name: 'Cambodia',
  },
  {
    code: 'CM',
    dial_code: '+237',
    flagUrl: 'https://flagcdn.com/24x18/cm.png',
    id: 120,
    name: 'Cameroon',
  },
  {
    code: 'CA',
    dial_code: '+1',
    flagUrl: 'https://flagcdn.com/24x18/ca.png',
    id: 124,
    name: 'Canada',
  },
  {
    code: 'CV',
    dial_code: '+238',
    flagUrl: 'https://flagcdn.com/24x18/cv.png',
    id: 132,
    name: 'Cabo Verde',
  },
  {
    code: 'CF',
    dial_code: '+236',
    flagUrl: 'https://flagcdn.com/24x18/cf.png',
    id: 140,
    name: 'Central African Republic',
  },
  {
    code: 'LK',
    dial_code: '+94',
    flagUrl: 'https://flagcdn.com/24x18/lk.png',
    id: 144,
    name: 'Sri Lanka',
  },
  {
    code: 'TD',
    dial_code: '+235',
    flagUrl: 'https://flagcdn.com/24x18/td.png',
    id: 148,
    name: 'Chad',
  },
  {
    code: 'CL',
    dial_code: '+56',
    flagUrl: 'https://flagcdn.com/24x18/cl.png',
    id: 152,
    name: 'Chile',
  },
  {
    code: 'CN',
    dial_code: '+86',
    flagUrl: 'https://flagcdn.com/24x18/cn.png',
    id: 156,
    name: 'China',
  },
  {
    code: 'CO',
    dial_code: '+57',
    flagUrl: 'https://flagcdn.com/24x18/co.png',
    id: 170,
    name: 'Colombia',
  },
  {
    code: 'KM',
    dial_code: '+269',
    flagUrl: 'https://flagcdn.com/24x18/km.png',
    id: 174,
    name: 'Comoros',
  },
  {
    code: 'CG',
    dial_code: '+242',
    flagUrl: 'https://flagcdn.com/24x18/cg.png',
    id: 178,
    name: 'Congo',
  },
  {
    code: 'CD',
    dial_code: '+243',
    flagUrl: 'https://flagcdn.com/24x18/cd.png',
    id: 180,
    name: 'Congo, Democratic Republic of the',
  },
  {
    code: 'CR',
    dial_code: '+506',
    flagUrl: 'https://flagcdn.com/24x18/cr.png',
    id: 188,
    name: 'Costa Rica',
  },
  {
    code: 'HR',
    dial_code: '+385',
    flagUrl: 'https://flagcdn.com/24x18/hr.png',
    id: 191,
    name: 'Croatia',
  },
  {
    code: 'CU',
    dial_code: '+53',
    flagUrl: 'https://flagcdn.com/24x18/cu.png',
    id: 192,
    name: 'Cuba',
  },
  {
    code: 'CY',
    dial_code: '+357',
    flagUrl: 'https://flagcdn.com/24x18/cy.png',
    id: 196,
    name: 'Cyprus',
  },
  {
    code: 'CZ',
    dial_code: '+420',
    flagUrl: 'https://flagcdn.com/24x18/cz.png',
    id: 203,
    name: 'Czechia',
  },
  {
    code: 'BJ',
    dial_code: '+229',
    flagUrl: 'https://flagcdn.com/24x18/bj.png',
    id: 204,
    name: 'Benin',
  },
  {
    code: 'DK',
    dial_code: '+45',
    flagUrl: 'https://flagcdn.com/24x18/dk.png',
    id: 208,
    name: 'Denmark',
  },
  {
    code: 'DM',
    dial_code: '+1767',
    flagUrl: 'https://flagcdn.com/24x18/dm.png',
    id: 212,
    name: 'Dominica',
  },
  {
    code: 'DO',
    dial_code: '+1849',
    flagUrl: 'https://flagcdn.com/24x18/do.png',
    id: 214,
    name: 'Dominican Republic',
  },
  {
    code: 'EC',
    dial_code: '+593',
    flagUrl: 'https://flagcdn.com/24x18/ec.png',
    id: 218,
    name: 'Ecuador',
  },
  {
    code: 'SV',
    dial_code: '+503',
    flagUrl: 'https://flagcdn.com/24x18/sv.png',
    id: 222,
    name: 'El Salvador',
  },
  {
    code: 'GQ',
    dial_code: '+240',
    flagUrl: 'https://flagcdn.com/24x18/gq.png',
    id: 226,
    name: 'Equatorial Guinea',
  },
  {
    code: 'ET',
    dial_code: '+251',
    flagUrl: 'https://flagcdn.com/24x18/et.png',
    id: 231,
    name: 'Ethiopia',
  },
  {
    code: 'ER',
    dial_code: '+291',
    flagUrl: 'https://flagcdn.com/24x18/er.png',
    id: 232,
    name: 'Eritrea',
  },
  {
    code: 'EE',
    dial_code: '+372',
    flagUrl: 'https://flagcdn.com/24x18/ee.png',
    id: 233,
    name: 'Estonia',
  },
  {
    code: 'FJ',
    dial_code: '+679',
    flagUrl: 'https://flagcdn.com/24x18/fj.png',
    id: 242,
    name: 'Fiji',
  },
  {
    code: 'FI',
    dial_code: '+358',
    flagUrl: 'https://flagcdn.com/24x18/fi.png',
    id: 246,
    name: 'Finland',
  },
  {
    code: 'FR',
    dial_code: '+33',
    flagUrl: 'https://flagcdn.com/24x18/fr.png',
    id: 250,
    name: 'France',
  },
  {
    code: 'DJ',
    dial_code: '+253',
    flagUrl: 'https://flagcdn.com/24x18/dj.png',
    id: 262,
    name: 'Djibouti',
  },
  {
    code: 'GA',
    dial_code: '+241',
    flagUrl: 'https://flagcdn.com/24x18/ga.png',
    id: 266,
    name: 'Gabon',
  },
  {
    code: 'GE',
    dial_code: '+995',
    flagUrl: 'https://flagcdn.com/24x18/ge.png',
    id: 268,
    name: 'Georgia',
  },
  {
    code: 'GM',
    dial_code: '+220',
    flagUrl: 'https://flagcdn.com/24x18/gm.png',
    id: 270,
    name: 'Gambia',
  },
  {
    code: 'DE',
    dial_code: '+49',
    flagUrl: 'https://flagcdn.com/24x18/de.png',
    id: 276,
    name: 'Germany',
  },
  {
    code: 'GH',
    dial_code: '+233',
    flagUrl: 'https://flagcdn.com/24x18/gh.png',
    id: 288,
    name: 'Ghana',
  },
  {
    code: 'KI',
    dial_code: '+686',
    flagUrl: 'https://flagcdn.com/24x18/ki.png',
    id: 296,
    name: 'Kiribati',
  },
  {
    code: 'GR',
    dial_code: '+30',
    flagUrl: 'https://flagcdn.com/24x18/gr.png',
    id: 300,
    name: 'Greece',
  },
  {
    code: 'GD',
    dial_code: '+1473',
    flagUrl: 'https://flagcdn.com/24x18/gd.png',
    id: 308,
    name: 'Grenada',
  },
  {
    code: 'GT',
    dial_code: '+502',
    flagUrl: 'https://flagcdn.com/24x18/gt.png',
    id: 320,
    name: 'Guatemala',
  },
  {
    code: 'GN',
    dial_code: '+224',
    flagUrl: 'https://flagcdn.com/24x18/gn.png',
    id: 324,
    name: 'Guinea',
  },
  {
    code: 'GY',
    dial_code: '+592',
    flagUrl: 'https://flagcdn.com/24x18/gy.png',
    id: 328,
    name: 'Guyana',
  },
  {
    code: 'HT',
    dial_code: '+509',
    flagUrl: 'https://flagcdn.com/24x18/ht.png',
    id: 332,
    name: 'Haiti',
  },
  {
    code: 'HN',
    dial_code: '+504',
    flagUrl: 'https://flagcdn.com/24x18/hn.png',
    id: 340,
    name: 'Honduras',
  },
  {
    code: 'HU',
    dial_code: '+36',
    flagUrl: 'https://flagcdn.com/24x18/hu.png',
    id: 348,
    name: 'Hungary',
  },
  {
    code: 'IS',
    dial_code: '+354',
    flagUrl: 'https://flagcdn.com/24x18/is.png',
    id: 352,
    name: 'Iceland',
  },
  {
    code: 'IN',
    dial_code: '+91',
    flagUrl: 'https://flagcdn.com/24x18/in.png',
    id: 356,
    name: 'India',
  },
  {
    code: 'ID',
    dial_code: '+62',
    flagUrl: 'https://flagcdn.com/24x18/id.png',
    id: 360,
    name: 'Indonesia',
  },
  {
    code: 'IR',
    dial_code: '+98',
    flagUrl: 'https://flagcdn.com/24x18/ir.png',
    id: 364,
    name: 'Iran (Islamic Republic of)',
  },
  {
    code: 'IQ',
    dial_code: '+964',
    flagUrl: 'https://flagcdn.com/24x18/iq.png',
    id: 368,
    name: 'Iraq',
  },
  {
    code: 'IE',
    dial_code: '+353',
    flagUrl: 'https://flagcdn.com/24x18/ie.png',
    id: 372,
    name: 'Ireland',
  },
  {
    code: 'IL',
    dial_code: '+972',
    flagUrl: 'https://flagcdn.com/24x18/il.png',
    id: 376,
    name: 'Israel',
  },
  {
    code: 'IT',
    dial_code: '+39',
    flagUrl: 'https://flagcdn.com/24x18/it.png',
    id: 380,
    name: 'Italy',
  },
  {
    code: 'CI',
    dial_code: '+225',
    flagUrl: 'https://flagcdn.com/24x18/ci.png',
    id: 384,
    name: "Côte d'Ivoire",
  },
  {
    code: 'JM',
    dial_code: '+1876',
    flagUrl: 'https://flagcdn.com/24x18/jm.png',
    id: 388,
    name: 'Jamaica',
  },
  {
    code: 'JP',
    dial_code: '+81',
    flagUrl: 'https://flagcdn.com/24x18/jp.png',
    id: 392,
    name: 'Japan',
  },
  {
    code: 'KZ',
    dial_code: '+77',
    flagUrl: 'https://flagcdn.com/24x18/kz.png',
    id: 398,
    name: 'Kazakhstan',
  },
  {
    code: 'JO',
    dial_code: '+962',
    flagUrl: 'https://flagcdn.com/24x18/jo.png',
    id: 400,
    name: 'Jordan',
  },
  {
    code: 'KE',
    dial_code: '+254',
    flagUrl: 'https://flagcdn.com/24x18/ke.png',
    id: 404,
    name: 'Kenya',
  },
  {
    code: 'KP',
    dial_code: '+850',
    flagUrl: 'https://flagcdn.com/24x18/kp.png',
    id: 408,
    name: "Korea (Democratic People's Republic of)",
  },
  {
    code: 'KR',
    dial_code: '+82',
    flagUrl: 'https://flagcdn.com/24x18/kr.png',
    id: 410,
    name: 'Korea, Republic of',
  },
  {
    code: 'KW',
    dial_code: '+965',
    flagUrl: 'https://flagcdn.com/24x18/kw.png',
    id: 414,
    name: 'Kuwait',
  },
  {
    code: 'KG',
    dial_code: '+996',
    flagUrl: 'https://flagcdn.com/24x18/kg.png',
    id: 417,
    name: 'Kyrgyzstan',
  },
  {
    code: 'LA',
    dial_code: '+856',
    flagUrl: 'https://flagcdn.com/24x18/la.png',
    id: 418,
    name: "Lao People's Democratic Republic",
  },
  {
    code: 'LB',
    dial_code: '+961',
    flagUrl: 'https://flagcdn.com/24x18/lb.png',
    id: 422,
    name: 'Lebanon',
  },
  {
    code: 'LS',
    dial_code: '+266',
    flagUrl: 'https://flagcdn.com/24x18/ls.png',
    id: 426,
    name: 'Lesotho',
  },
  {
    code: 'LV',
    dial_code: '+371',
    flagUrl: 'https://flagcdn.com/24x18/lv.png',
    id: 428,
    name: 'Latvia',
  },
  {
    code: 'LR',
    dial_code: '+231',
    flagUrl: 'https://flagcdn.com/24x18/lr.png',
    id: 430,
    name: 'Liberia',
  },
  {
    code: 'LY',
    dial_code: '+218',
    flagUrl: 'https://flagcdn.com/24x18/ly.png',
    id: 434,
    name: 'Libya',
  },
  {
    code: 'LI',
    dial_code: '+423',
    flagUrl: 'https://flagcdn.com/24x18/li.png',
    id: 438,
    name: 'Liechtenstein',
  },
  {
    code: 'LT',
    dial_code: '+370',
    flagUrl: 'https://flagcdn.com/24x18/lt.png',
    id: 440,
    name: 'Lithuania',
  },
  {
    code: 'LU',
    dial_code: '+352',
    flagUrl: 'https://flagcdn.com/24x18/lu.png',
    id: 442,
    name: 'Luxembourg',
  },
  {
    code: 'MG',
    dial_code: '+261',
    flagUrl: 'https://flagcdn.com/24x18/mg.png',
    id: 450,
    name: 'Madagascar',
  },
  {
    code: 'MW',
    dial_code: '+265',
    flagUrl: 'https://flagcdn.com/24x18/mw.png',
    id: 454,
    name: 'Malawi',
  },
  {
    code: 'MY',
    dial_code: '+60',
    flagUrl: 'https://flagcdn.com/24x18/my.png',
    id: 458,
    name: 'Malaysia',
  },
  {
    code: 'MV',
    dial_code: '+960',
    flagUrl: 'https://flagcdn.com/24x18/mv.png',
    id: 462,
    name: 'Maldives',
  },
  {
    code: 'ML',
    dial_code: '+223',
    flagUrl: 'https://flagcdn.com/24x18/ml.png',
    id: 466,
    name: 'Mali',
  },
  {
    code: 'MT',
    dial_code: '+356',
    flagUrl: 'https://flagcdn.com/24x18/mt.png',
    id: 470,
    name: 'Malta',
  },
  {
    code: 'MR',
    dial_code: '+222',
    flagUrl: 'https://flagcdn.com/24x18/mr.png',
    id: 478,
    name: 'Mauritania',
  },
  {
    code: 'MU',
    dial_code: '+230',
    flagUrl: 'https://flagcdn.com/24x18/mu.png',
    id: 480,
    name: 'Mauritius',
  },
  {
    code: 'MX',
    dial_code: '+52',
    flagUrl: 'https://flagcdn.com/24x18/mx.png',
    id: 484,
    name: 'Mexico',
  },
  {
    code: 'MC',
    dial_code: '+377',
    flagUrl: 'https://flagcdn.com/24x18/mc.png',
    id: 492,
    name: 'Monaco',
  },
  {
    code: 'MN',
    dial_code: '+976',
    flagUrl: 'https://flagcdn.com/24x18/mn.png',
    id: 496,
    name: 'Mongolia',
  },
  {
    code: 'MD',
    dial_code: '+373',
    flagUrl: 'https://flagcdn.com/24x18/md.png',
    id: 498,
    name: 'Moldova, Republic of',
  },
  {
    code: 'ME',
    dial_code: '+382',
    flagUrl: 'https://flagcdn.com/24x18/me.png',
    id: 499,
    name: 'Montenegro',
  },
  {
    code: 'MA',
    dial_code: '+212',
    flagUrl: 'https://flagcdn.com/24x18/ma.png',
    id: 504,
    name: 'Morocco',
  },
  {
    code: 'MZ',
    dial_code: '+258',
    flagUrl: 'https://flagcdn.com/24x18/mz.png',
    id: 508,
    name: 'Mozambique',
  },
  {
    code: 'OM',
    dial_code: '+968',
    flagUrl: 'https://flagcdn.com/24x18/om.png',
    id: 512,
    name: 'Oman',
  },
  {
    code: 'NA',
    dial_code: '+264',
    flagUrl: 'https://flagcdn.com/24x18/na.png',
    id: 516,
    name: 'Namibia',
  },
  {
    code: 'NR',
    dial_code: '+674',
    flagUrl: 'https://flagcdn.com/24x18/nr.png',
    id: 520,
    name: 'Nauru',
  },
  {
    code: 'NP',
    dial_code: '+977',
    flagUrl: 'https://flagcdn.com/24x18/np.png',
    id: 524,
    name: 'Nepal',
  },
  {
    code: 'NL',
    dial_code: '+31',
    flagUrl: 'https://flagcdn.com/24x18/nl.png',
    id: 528,
    name: 'Netherlands',
  },
  {
    code: 'VU',
    dial_code: '+678',
    flagUrl: 'https://flagcdn.com/24x18/vu.png',
    id: 548,
    name: 'Vanuatu',
  },
  {
    code: 'NZ',
    dial_code: '+64',
    flagUrl: 'https://flagcdn.com/24x18/nz.png',
    id: 554,
    name: 'New Zealand',
  },
  {
    code: 'NI',
    dial_code: '+505',
    flagUrl: 'https://flagcdn.com/24x18/ni.png',
    id: 558,
    name: 'Nicaragua',
  },
  {
    code: 'NE',
    dial_code: '+227',
    flagUrl: 'https://flagcdn.com/24x18/ne.png',
    id: 562,
    name: 'Niger',
  },
  {
    code: 'NG',
    dial_code: '+234',
    flagUrl: 'https://flagcdn.com/24x18/ng.png',
    id: 566,
    name: 'Nigeria',
  },
  {
    code: 'NO',
    dial_code: '+47',
    flagUrl: 'https://flagcdn.com/24x18/no.png',
    id: 578,
    name: 'Norway',
  },
  {
    code: 'FM',
    dial_code: '+691',
    flagUrl: 'https://flagcdn.com/24x18/fm.png',
    id: 583,
    name: 'Micronesia (Federated States of)',
  },
  {
    code: 'MH',
    dial_code: '+692',
    flagUrl: 'https://flagcdn.com/24x18/mh.png',
    id: 584,
    name: 'Marshall Islands',
  },
  {
    code: 'PW',
    dial_code: '+680',
    flagUrl: 'https://flagcdn.com/24x18/pw.png',
    id: 585,
    name: 'Palau',
  },
  {
    code: 'PK',
    dial_code: '+92',
    flagUrl: 'https://flagcdn.com/24x18/pk.png',
    id: 586,
    name: 'Pakistan',
  },
  {
    code: 'PA',
    dial_code: '+507',
    flagUrl: 'https://flagcdn.com/24x18/pa.png',
    id: 591,
    name: 'Panama',
  },
  {
    code: 'PG',
    dial_code: '+675',
    flagUrl: 'https://flagcdn.com/24x18/pg.png',
    id: 598,
    name: 'Papua New Guinea',
  },
  {
    code: 'PY',
    dial_code: '+595',
    flagUrl: 'https://flagcdn.com/24x18/py.png',
    id: 600,
    name: 'Paraguay',
  },
  {
    code: 'PE',
    dial_code: '+51',
    flagUrl: 'https://flagcdn.com/24x18/pe.png',
    id: 604,
    name: 'Peru',
  },
  {
    code: 'PH',
    dial_code: '+63',
    flagUrl: 'https://flagcdn.com/24x18/ph.png',
    id: 608,
    name: 'Philippines',
  },
  {
    code: 'PL',
    dial_code: '+48',
    flagUrl: 'https://flagcdn.com/24x18/pl.png',
    id: 616,
    name: 'Poland',
  },
  {
    code: 'PT',
    dial_code: '+351',
    flagUrl: 'https://flagcdn.com/24x18/pt.png',
    id: 620,
    name: 'Portugal',
  },
  {
    code: 'GW',
    dial_code: '+245',
    flagUrl: 'https://flagcdn.com/24x18/gw.png',
    id: 624,
    name: 'Guinea-Bissau',
  },
  {
    code: 'TL',
    dial_code: '+670',
    flagUrl: 'https://flagcdn.com/24x18/tl.png',
    id: 626,
    name: 'Timor-Leste',
  },
  {
    code: 'QA',
    dial_code: '+974',
    flagUrl: 'https://flagcdn.com/24x18/qa.png',
    id: 634,
    name: 'Qatar',
  },
  {
    code: 'RO',
    dial_code: '+40',
    flagUrl: 'https://flagcdn.com/24x18/ro.png',
    id: 642,
    name: 'Romania',
  },
  {
    code: 'RU',
    dial_code: '+7',
    flagUrl: 'https://flagcdn.com/24x18/ru.png',
    id: 643,
    name: 'Russian Federation',
  },
  {
    code: 'RW',
    dial_code: '+250',
    flagUrl: 'https://flagcdn.com/24x18/rw.png',
    id: 646,
    name: 'Rwanda',
  },
  {
    code: 'KN',
    dial_code: '+1869',
    flagUrl: 'https://flagcdn.com/24x18/kn.png',
    id: 659,
    name: 'Saint Kitts and Nevis',
  },
  {
    code: 'LC',
    dial_code: '+1758',
    flagUrl: 'https://flagcdn.com/24x18/lc.png',
    id: 662,
    name: 'Saint Lucia',
  },
  {
    code: 'VC',
    dial_code: '+1784',
    flagUrl: 'https://flagcdn.com/24x18/vc.png',
    id: 670,
    name: 'Saint Vincent and the Grenadines',
  },
  {
    code: 'SM',
    dial_code: '+378',
    flagUrl: 'https://flagcdn.com/24x18/sm.png',
    id: 674,
    name: 'San Marino',
  },
  {
    code: 'ST',
    dial_code: '+239',
    flagUrl: 'https://flagcdn.com/24x18/st.png',
    id: 678,
    name: 'Sao Tome and Principe',
  },
  {
    code: 'SA',
    dial_code: '+966',
    flagUrl: 'https://flagcdn.com/24x18/sa.png',
    id: 682,
    name: 'Saudi Arabia',
  },
  {
    code: 'SN',
    dial_code: '+221',
    flagUrl: 'https://flagcdn.com/24x18/sn.png',
    id: 686,
    name: 'Senegal',
  },
  {
    code: 'RS',
    dial_code: '+381',
    flagUrl: 'https://flagcdn.com/24x18/rs.png',
    id: 688,
    name: 'Serbia',
  },
  {
    code: 'SC',
    dial_code: '+248',
    flagUrl: 'https://flagcdn.com/24x18/sc.png',
    id: 690,
    name: 'Seychelles',
  },
  {
    code: 'SL',
    dial_code: '+232',
    flagUrl: 'https://flagcdn.com/24x18/sl.png',
    id: 694,
    name: 'Sierra Leone',
  },
  {
    code: 'SG',
    dial_code: '+65',
    flagUrl: 'https://flagcdn.com/24x18/sg.png',
    id: 702,
    name: 'Singapore',
  },
  {
    code: 'SK',
    dial_code: '+421',
    flagUrl: 'https://flagcdn.com/24x18/sk.png',
    id: 703,
    name: 'Slovakia',
  },
  {
    code: 'VN',
    dial_code: '+84',
    flagUrl: 'https://flagcdn.com/24x18/vn.png',
    id: 704,
    name: 'Viet Nam',
  },
  {
    code: 'SI',
    dial_code: '+386',
    flagUrl: 'https://flagcdn.com/24x18/si.png',
    id: 705,
    name: 'Slovenia',
  },
  {
    code: 'SO',
    dial_code: '+252',
    flagUrl: 'https://flagcdn.com/24x18/so.png',
    id: 706,
    name: 'Somalia',
  },
  {
    code: 'ZA',
    dial_code: '+27',
    flagUrl: 'https://flagcdn.com/24x18/za.png',
    id: 710,
    name: 'South Africa',
  },
  {
    code: 'ZW',
    dial_code: '+263',
    flagUrl: 'https://flagcdn.com/24x18/zw.png',
    id: 716,
    name: 'Zimbabwe',
  },
  {
    code: 'ES',
    dial_code: '+34',
    flagUrl: 'https://flagcdn.com/24x18/es.png',
    id: 724,
    name: 'Spain',
  },
  {
    code: 'SS',
    dial_code: '+211',
    flagUrl: 'https://flagcdn.com/24x18/ss.png',
    id: 728,
    name: 'South Sudan',
  },
  {
    code: 'SD',
    dial_code: '+249',
    flagUrl: 'https://flagcdn.com/24x18/sd.png',
    id: 729,
    name: 'Sudan',
  },
  {
    code: 'SR',
    dial_code: '+597',
    flagUrl: 'https://flagcdn.com/24x18/sr.png',
    id: 740,
    name: 'Suriname',
  },
  {
    code: 'SZ',
    dial_code: '+268',
    flagUrl: 'https://flagcdn.com/24x18/sz.png',
    id: 748,
    name: 'Eswatini',
  },
  {
    code: 'SE',
    dial_code: '+46',
    flagUrl: 'https://flagcdn.com/24x18/se.png',
    id: 752,
    name: 'Sweden',
  },
  {
    code: 'CH',
    dial_code: '+41',
    flagUrl: 'https://flagcdn.com/24x18/ch.png',
    id: 756,
    name: 'Switzerland',
  },
  {
    code: 'SY',
    dial_code: '+963',
    flagUrl: 'https://flagcdn.com/24x18/sy.png',
    id: 760,
    name: 'Syrian Arab Republic',
  },
  {
    code: 'TJ',
    dial_code: '+992',
    flagUrl: 'https://flagcdn.com/24x18/tj.png',
    id: 762,
    name: 'Tajikistan',
  },
  {
    code: 'TH',
    dial_code: '+66',
    flagUrl: 'https://flagcdn.com/24x18/th.png',
    id: 764,
    name: 'Thailand',
  },
  {
    code: 'TG',
    dial_code: '+228',
    flagUrl: 'https://flagcdn.com/24x18/tg.png',
    id: 768,
    name: 'Togo',
  },
  {
    code: 'TO',
    dial_code: '+676',
    flagUrl: 'https://flagcdn.com/24x18/to.png',
    id: 776,
    name: 'Tonga',
  },
  {
    code: 'TT',
    dial_code: '+1868',
    flagUrl: 'https://flagcdn.com/24x18/tt.png',
    id: 780,
    name: 'Trinidad and Tobago',
  },
  {
    code: 'AE',
    dial_code: '+971',
    flagUrl: 'https://flagcdn.com/24x18/ae.png',
    id: 784,
    name: 'United Arab Emirates',
  },
  {
    code: 'TN',
    dial_code: '+216',
    flagUrl: 'https://flagcdn.com/24x18/tn.png',
    id: 788,
    name: 'Tunisia',
  },
  {
    code: 'TR',
    dial_code: '+90',
    flagUrl: 'https://flagcdn.com/24x18/tr.png',
    id: 792,
    name: 'Turkey',
  },
  {
    code: 'TM',
    dial_code: '+993',
    flagUrl: 'https://flagcdn.com/24x18/tm.png',
    id: 795,
    name: 'Turkmenistan',
  },
  {
    code: 'TV',
    dial_code: '+688',
    flagUrl: 'https://flagcdn.com/24x18/tv.png',
    id: 798,
    name: 'Tuvalu',
  },
  {
    code: 'UG',
    dial_code: '+256',
    flagUrl: 'https://flagcdn.com/24x18/ug.png',
    id: 800,
    name: 'Uganda',
  },
  {
    code: 'UA',
    dial_code: '+380',
    flagUrl: 'https://flagcdn.com/24x18/ua.png',
    id: 804,
    name: 'Ukraine',
  },
  {
    code: 'MK',
    dial_code: '+389',
    flagUrl: 'https://flagcdn.com/24x18/mk.png',
    id: 807,
    name: 'North Macedonia',
  },
  {
    code: 'EG',
    dial_code: '+20',
    flagUrl: 'https://flagcdn.com/24x18/eg.png',
    id: 818,
    name: 'Egypt',
  },
  {
    code: 'GB',
    dial_code: '+44',
    flagUrl: 'https://flagcdn.com/24x18/gb.png',
    id: 826,
    name: 'United Kingdom of Great Britain and Northern Ireland',
  },
  {
    code: 'TZ',
    dial_code: '+255',
    flagUrl: 'https://flagcdn.com/24x18/tz.png',
    id: 834,
    name: 'Tanzania, United Republic of',
  },
  {
    code: 'US',
    dial_code: '+1',
    flagUrl: 'https://flagcdn.com/24x18/us.png',
    id: 840,
    name: 'United States of America',
  },
  {
    code: 'BF',
    dial_code: '+226',
    flagUrl: 'https://flagcdn.com/24x18/bf.png',
    id: 854,
    name: 'Burkina Faso',
  },
  {
    code: 'UY',
    dial_code: '+598',
    flagUrl: 'https://flagcdn.com/24x18/uy.png',
    id: 858,
    name: 'Uruguay',
  },
  {
    code: 'UZ',
    dial_code: '+998',
    flagUrl: 'https://flagcdn.com/24x18/uz.png',
    id: 860,
    name: 'Uzbekistan',
  },
  {
    code: 'VE',
    dial_code: '+58',
    flagUrl: 'https://flagcdn.com/24x18/ve.png',
    id: 862,
    name: 'Venezuela (Bolivarian Republic of)',
  },
  {
    code: 'WS',
    dial_code: '+685',
    flagUrl: 'https://flagcdn.com/24x18/ws.png',
    id: 882,
    name: 'Samoa',
  },
  {
    code: 'YE',
    dial_code: '+967',
    flagUrl: 'https://flagcdn.com/24x18/ye.png',
    id: 887,
    name: 'Yemen',
  },
  {
    code: 'ZM',
    dial_code: '+260',
    flagUrl: 'https://flagcdn.com/24x18/zm.png',
    id: 894,
    name: 'Zambia',
  },
];
